import { call, put, takeEvery } from "redux-saga/effects";
import { LOGIN_USER, LOGOUT_USER, TWO_FACTOR_REQUIRED } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess, twoFactorRequired } from "./actions";
import api, { handleApiError } from "../../../helpers/api"; // Import the custom API

function* loginUser({ payload: { user, navigate } }) {
  try {
    console.log("Login user payload:", user);

    const response = yield call(
        api.post,
        'user/login',
        {
          email: user.email,
          password: user.password,
          totpCode: user.totpCode,
        }
    );
    console.log("Login response:", response);

    if (response.data.status === 'success') {
      localStorage.setItem("user", JSON.stringify(response.data.user));
      yield put(loginSuccess(response.data.user));
      navigate('/dashboard');
    } else if (response.data.status === 'desactive') {
      yield put(apiError("Your account is deactivated. Please contact system administrator.", false));
    } else if (response.data.status === 'TOTP code required') {
      yield put(twoFactorRequired());
    } else {
      yield put(apiError(response.data.message || "Invalid email or password", false));
    }
  } catch (error) {
    console.log("Login error:", error.response || error.message);
    yield handleApiError(error, yield put, navigate);
  }
}

function* logoutUser({ payload: { navigate } }) {
  try {
    console.log("Logout user action triggered");
    const response = yield call(
        api.get,
        'user/logout',
        {
          timeout: 5000,
        }
    );
    console.log("Logout response:", response);

    if (response.data.status === 'success') {
      localStorage.removeItem("user");
      yield put(logoutUserSuccess());
      navigate('/login');
    } else {
      yield put(apiError(response.data.message || "Logout failed"));
    }
  } catch (error) {
    console.log("Logout error:", error.response?.data || error.message);
    yield handleApiError(error, yield put, navigate);
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;